export default "__VITE_ASSET__DuBEqHCS__"